"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressSelectInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const utils_1 = require("../../utils");
const AddressSelectInput = (props) => {
    const { name = "addressId" } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const userId = (0, react_hook_form_1.useWatch)({ name: "userId" });
    const { formatAddress } = (0, utils_1.useFormatAddress)();
    (0, react_1.useEffect)(() => {
        form.setValue(name, 0);
    }, [userId]);
    if (!userId) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: name, controller: "ecommerce/address", fetchData: { userId }, getTitle: formatAddress, autoSelect: true }));
};
exports.AddressSelectInput = AddressSelectInput;
//# sourceMappingURL=index.js.map